import CountUp from 'react-countup';
import styled from 'styled-components';

import { ADSHeading } from '@aphrodite/common-ui';
import { ADSText } from '@aphrodite/common-ui';

import StatsBackground from '../../assets/images/landing_stats_background.png';

const StyledCardDiv = styled.div`
  left: 0px;
  padding-bottom: 52px;
  display: flex;
  flex-direction: column;
  padding-left: 8%;
  padding-right: 8%;
  height: 70vh;
  width: 100vw;
  @media only screen and (min-width: 680px) {
    height: 60vh;
    min-height: 600px;
  }
  @media only screen and (min-width: 1440px) {
    padding-left: 16%;
    padding-right: 16%;
  }
`;
const StyledStatsDiv = styled(StyledCardDiv)`
  background-image: url(${StatsBackground});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 568px) {
    margin-bottom: 12px;
  }
`;
const StyledStatDiv = styled.div`
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-right: 8%;
  padding-bottom: 8%;
  height: 100vh;
  @media only screen and (min-width: 680px) {
    padding-right: 0px;
    height: 40vh;
  }
`;
const StyledFlexDiv = styled.div`
  width: match-parent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8vw;
  margin-right: auto;
  margin-bottom: 20px;
  @media only screen and (min-width: 680px) {
    margin: 1vh 0;
    align-items: center;
  }
  .Stat {
    font-size: 40px;
  }
`;
interface Props {
  signUpCount: number;
}

export default function LandingStats({ signUpCount }: Props): React.ReactElement {
  const renderMatchCount = () => {
    // 2023 Singapore: 4755
    // 2024: NA + HK: 8798
    // 2024 Singapore: 4174
    // 2025 Singapore: 2261
    // 2025 Valentine's: 6417
    // 2026 Singapore: 2310
    return (
      <StyledFlexDiv>
        <ADSHeading className="Stat" weight="bold">
          <CountUp end={signUpCount + 105183} duration={1} />
        </ADSHeading>
        <ADSText>Matched since 2019</ADSText>
      </StyledFlexDiv>
    );
  };

  return (
    <StyledStatsDiv>
      <StyledStatDiv>
        {renderMatchCount()}
        <StyledFlexDiv>
          <ADSHeading className="Stat" weight="bold">
            2 in 5
          </ADSHeading>
          <ADSText>Met up with their match</ADSText>
        </StyledFlexDiv>
        <StyledFlexDiv>
          <ADSHeading className="Stat" weight="bold">
            14
          </ADSHeading>
          <ADSText>Engagements and Marriages</ADSText>
        </StyledFlexDiv>
      </StyledStatDiv>
    </StyledStatsDiv>
  );
}
